import { Dispatch, createSelector } from '@reduxjs/toolkit';
import { navigateToHashWithTabBarOffset } from 'component/common/DetailInViewWrapper/navigateToHashWithTabBarOffset';
import { setExpandedAccordionOnDetailsPage, setIsScrolling, setSelectedTabOnDetailsPage } from 'component/page/detail/store/details';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesDetailsPageTabClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesDetailsPageTabClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { SCROLLING_TIMEOUT } from 'core/constant/AnimationTimeout';
import { selectDetailState, selectSelectedTabFromDetailState, selectIsScrolling } from 'component/page/detail/store/detail.selectors';
import { ContentConfig } from 'component/page/detail/DetailPageModularize/contentRegistry.type';

export const shiftFocusByIndexAndHref = (href: string) => {
    const nextFocusElementWithButton = document.querySelector(`#${href} button`) as HTMLElement;
    const nextFocusElementWithHeading = document.querySelector(`#${href} h1, #${href} h2, #${href} h3, #${href} h4, #${href} h5, #${href} h6`) as HTMLElement;
    const nextFocusElementWithButtonOrHeading = nextFocusElementWithButton || nextFocusElementWithHeading;

    setTimeout(() => {
        nextFocusElementWithButtonOrHeading?.focus({ preventScroll: true });
    }, 500);
};

export interface Tab {
    title: string;
    href: string;
}

interface StateProps {
    isSuccess: boolean;
    selectedTab: string;
    isScrolling: boolean;
}

export interface DispatchProps {
    onTabChanged: (tab: Tab) => void;
}

interface OwnProps {
    contents: ContentConfig[];
}

export type TabsComponentProps = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = createSelector(selectDetailState, selectSelectedTabFromDetailState, selectIsScrolling, (state, selectedTab, isScrolling): StateProps => {
    return { isSuccess: state.isSuccess, selectedTab, isScrolling };
});

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    onTabChanged: (tab: Tab) => {
        dispatch(setIsScrolling(true));
        dispatch(setExpandedAccordionOnDetailsPage({ selector: `#${tab.href}`, status: true }));
        navigateToHashWithTabBarOffset(dispatch, `#${tab.href}`, setIsScrolling);
        trackElementEvent<ActivitiesDetailsPageTabClickEventActivitiesFieldsV1>(ActivitiesDetailsPageTabClickEventActivitiesManifestV1.ids, {}, { action_element_value: tab.href });
        // prevent tabs focus
        setTimeout(() => {
            setTimeout(() => {
                dispatch(setIsScrolling(false));
                dispatch(setSelectedTabOnDetailsPage(tab.href)); // Need to dispatch slightly after reactivated InView to override selectedTab
            }, 40);
        }, SCROLLING_TIMEOUT);
    },
});
